<template lang="pug">
  .greenhouse-job-board.container
    .row
      .fixed-width-tweak-upper
        .jobs-wrap.xs-12
          h2.f-secondary.xs-f-xxxlarge.sm-f-grande.md-f-xgrande.lg-f-xgrande.max-at-tweak {{ title }}

          .department-wrap(v-for="department in departmentMap" :key="department.title")
            h3.semi-bold.upper.xs-f-medium.sm-f-large.md-f-xlarge.lg-f-large.max-at-tweak {{ department.title }}

            .location(v-for="(values, key) in department.jobs" :key="key")

              h4.semi-bold.upper.xs-f-xsmall.lg-f-small.max-at-tweak.location-title(v-if="Object.keys(department.jobs).length > 1") {{ key }}

              .job-wrap(v-for="(job, index) in values" :key="index")
                a.brand-color-2.semi-bold.line-height-small.xs-f-small.sm-f-xmedium.md-f-large.lg-f-xmedium.max-at-tweak(
                  :href="jobUrl(job)" 
                  target="_blank"
                  tabindex="0"
                ) {{ job.title }}
                p.text-color-2.xs-f-xsmall.sm-f-small.md-f-medium.lg-f-small.max-at-tweak {{ job.location.name }}
</template>
<script>
  import { mapActions } from 'vuex';
  import { getJobsFromBoard, getJobsFromPuckBoard } from '@services/vueGreenhouseSvc';

  export default {
    name: 'GreenHouseJobBoard',

    props: {
      title: {
        type: String,
        default: '',
      },
      jobBoardName: {
        type: String,
        default: '',
      },
      baseUrl: {
        type: String,
        default: '',
      },
      puckBoard: {
        type: Boolean,
        default: false,
        required: false
      }
    },

    data() {
      return ({
        jobs: [],
      });
    },

    computed: {
      departmentMap() {
        let departmentMap = {};

        this.jobs.forEach(job => {
          Object.keys(job.departments).forEach(departmentKey => {
            let department = job.departments[departmentKey];

            if (!department || !department.name) {
              return;
            }

            if (!departmentMap[department.name]) {
              departmentMap[department.name] = {
                title: department.name,
                jobs: {}
              };
            }

            if (!departmentMap[department.name].jobs[job.state]) {
              departmentMap[department.name].jobs[job.state] = [];
            }

            departmentMap[department.name].jobs[job.state].push(job);
          });
        });

        return departmentMap;
      },
    },

    mounted() {
      this.getJobs();
    },

    methods: {
      ...mapActions(['notifyError']),

      getJobs() {
        const getJobs = this.puckBoard ? getJobsFromPuckBoard : getJobsFromBoard;
        return getJobs({ boardName: this.jobBoardName }).then(res => {
          this.processJobs(res.data.jobs);
        }).catch(this.notifyError);
      },

      jobUrl(job) {
        return this.puckBoard ? job.absolute_url : this.ghJobUrl(job);
      },

      ghJobUrl(job) {
        let title = job.title.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, "").replace(/^\s+|\s+$/g, "").replace(/\s+/g, "-");
        return `${this.baseUrl}${this.jobBoardName}/${title}/${job.id}?gh_src=mrJobBoard`;
      },

      processJobs(jobs) {
        jobs.forEach(job => {
          if (job.location && job.location.name) {
            let cityState = job.location.name.split(',');

            if (cityState[0]) {
              job.city = cityState[0];
            }

            if (cityState[1]) {
              job.state = cityState[1].replace(' ', '').trim();
            } else {
              job.state = 'ALL LOCATIONS';
            }
          }

          job.mixin = job.title.toLowerCase();
          job.mixin = job.mixin.replace(/[^a-zA-Z0-9 ]/g, ''); // remove special characters
          job.mixin = job.mixin.replace(/^\s+|\s+$/g, ''); // remove leading/trailing spaces
          job.mixin = job.mixin.replace(/\s+/g, '-'); // replace spaces with dashes
        });

        this.jobs = jobs.sort((first, second) => {
          if (first.state < second.state || first.city < second.city || first.title < second.title) {
            return -1;
          } else if (first.state > second.state || first.city > second.city || first.title > second.title) {
            return 1;
          } else {
            return 0;
          }
        });
      },
    },
  };
</script>
<style lang="stylus" scoped>
.greenhouse-job-board
  .jobs-wrap
    padding 2em 5%

    h2
      padding-bottom 0.25em

    h3
      padding 0.75em 0

    .job-wrap
      padding-bottom 1.5em
</style>
